import { useLocation } from 'react-router-dom';

/** '/owner' or '/desk' etc. — the portal this page is shown in, so shared pages link inside the same portal. */
export function useBase(): string {
  const { pathname } = useLocation();
  return '/' + (pathname.split('/').filter(Boolean)[0] ?? 'owner');
}
